import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { HiOutlineArrowRight, HiOutlineClock, HiTag } from "react-icons/hi2";
import { baseurl, imgurl } from "../baseurl";
import "../asset/css/packages.css";

const Packages = () => {
  const { slug } = useParams(); // Gets 'yatra', 'holiday', etc. from URL
  const [packages, setPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Map URL slugs to your API's package_type field
  const categoryMap = {
    yatra: "Yatra Package",
    holiday: "Holiday Package",
    honeymoon: "Honeymoon Package",
    adventure: "Adventure"
  };

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${baseurl}/getAllPackages`);
        if (response.data.status === "success") {
          const allData = response.data.data;
          setPackages(allData);
          
          // Filter data based on current slug
          if (slug && categoryMap[slug]) {
            const filtered = allData.filter(
              (pkg) => pkg.package_type === categoryMap[slug]
            );
            setFilteredPackages(filtered);
          } else {
            setFilteredPackages(allData);
          }
        }
      } catch (error) {
        console.error("Error fetching packages:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPackages();
  }, [slug]); // Re-run whenever the URL slug changes

  if (loading) {
    return <div className="loader-container">Loading amazing deals...</div>;
  }

  // Determine Hero Title
  const heroTitle = slug ? categoryMap[slug] || "Our Packages" : "All Tour Packages";

  return (
    <div className="packages-page">
      {/* --- Dynamic Hero Section --- */}
      <section className={`package-hero ${slug || 'default'}`}>
        <div className="container h-100 d-flex align-items-center justify-content-center">
          <div className="text-center text-white">
            <h6 className="text-uppercase letter-spacing-3 mb-3">Explore Your Dream</h6>
            <h1 className="display-3 fw-bold">{heroTitle}</h1>
            <div className="breadcrumb-custom">
              Home <HiOutlineArrowRight className="mx-2" /> Packages <HiOutlineArrowRight className="mx-2" /> {heroTitle}
            </div>
          </div>
        </div>
      </section>

      {/* --- Packages Grid Section --- */}
      <section className="popular-packages-section container py-5 mt-4">
        <div className="section-header text-center mb-5">
          <h2 className="fw-bold">Discover {heroTitle}</h2>
          <div className="underline mx-auto"></div>
        </div>

        {filteredPackages.length > 0 ? (
          <div className="row g-4">
            {filteredPackages.map((pkg) => (
              <div className="col-lg-4 col-md-6" key={pkg.id}>
                <div className="package-card shadow-sm">
                  <div className="package-img-wrapper">
                    <img 
                      src={`${imgurl}/uploads/${pkg.banner_path}`} 
                      alt={pkg.package_name} 
                      className="package-img" 
                    />
                    <div className="package-badge">{pkg.package_type}</div>
                    <div className="package-price-tag">
                      <span className="currency">₹</span> {pkg.price} 
                    </div>
                  </div>

                  <div className="package-content p-4">
                    <div className="d-flex align-items-center mb-2 text-muted small">
                      <HiOutlineClock className="me-1 text-teal" /> 
                      <span>Fixed Departure</span>
                    </div>
                    <h4 className="package-title mb-3">{pkg.package_name}</h4>
                    <p className="package-desc text-muted mb-4">
                      {pkg.package_description.substring(0, 100)}...
                    </p>
                    <div className="package-footer d-flex justify-content-between align-items-center pt-3 border-top">
                      <div className="d-flex align-items-center text-teal fw-bold">
                        <HiTag className="me-1" /> Best Deal
                      </div>
                      <Link to={`/package/${pkg.id}`} className="btn-details">
                        View Details <HiOutlineArrowRight className="ms-1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-5">
            <h3>No packages found in this category.</h3>
            <p>Please check back later or explore our other exciting tours.</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default Packages;